<template>
	<div class="side-menu-wrap">
		<button class="btn primary-btn js-toggle-side-menu hide-desktop" type="button">Section Menu <span class="icon-angle-down"></span></button>

		<aside class="side-menu js-side-menu">
			<a v-bind:href="header.Url">
				<h3 class="side-menu-heading">{{ header.Label }}</h3>
			</a>
			<ul v-bind:class="sideMenuClass()">
				<menu-item v-for="(item, index) in sidebar" v-bind:item="item" v-bind:key="index"></menu-item>
			</ul>
		</aside>
	</div>
</template>

<script>
	import MenuItem from '../ui/menu-item';

	export default {
		props: ['sidebar', 'header', 'hideChildren'],
		components: {
			'menu-item': MenuItem,
		},
		mounted: function () {

		},
		methods: {
			sideMenuClass() {
				return "side-menu-primary" + (this.hideChildren ? " hide-active-children" : "")
			}
        },
    }
</script>